<h1 class="setting-title" i18n="@@settings_helpContact_title">
  Help & contact
</h1>
<h3 class="mb-3 subtitle-setting" i18n="@@settings_helpContact_helpSubtitle">
  Guide d’utilisation
</h3>
<p class="link-pdf">
  <a
    [href]="'assets/documents/IFU-' + link_lang + '.pdf'"
    target="_blank"
    class="link justify-content-start fw-semi-bold"
  >
    <img class="icon-document" src="assets/icons/icon-document.svg" alt="doc" />
    <span i18n="@@settings_helpContact_referToUserGuide"
      >Refer to the user guide</span
    ></a
  >
</p>
<h3
  class="mb-3 subtitle-setting second-subtile"
  i18n="@@settings_helpContact_contactSubtitle"
>
  Contact
</h3>
<p i18n="@@settings_helpContact_contactDescription">
  Are you having difficulty using NMOSD®? Our team is available to answer you.
</p>
<p class="link-pdf">
  <a
    href="mailto:equipe@nmosdcopilot.com"
    class="link justify-content-start fw-semi-bold"
  >
    <img class="icon-document" src="assets/icons/icon-mail.svg" alt="doc" />
    equipe@nmosdcopilot.com
  </a>
</p>
